'use client';

/**
 * WebQAFollowupsCard — Reception follow-up question chips.
 *
 * Reads `useDocsStore.response.followup_suggestions`. A quiet pill row;
 * for now the chips are display-only — wiring a chip click to re-ask
 * via docs.ask on the same conversation_id is the next increment.
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain canvas
 */

import { useDocsStore } from '@/lib/stores/docs-store';
import { useCardTypography } from '@/lib/design/card-chrome';
import { cn } from '@/lib/utils/cn';
import { FastTierSourceTag } from './web-qa-fast-source';
import { QA_SECTION, QA_BOX } from './web-qa-chrome';


export function WebQAFollowupsCard() {
  const T = useCardTypography();
  const response = useDocsStore((s) => s.response);

  if (!response) return null;

  const followups = response.followup_suggestions ?? [];
  if (followups.length === 0) return null;

  return (
    <section className={QA_SECTION}>
      <div className="w-full">
        <div className={QA_BOX}>
          <FastTierSourceTag />
          <div className={cn(T.metadata, 'mb-3 uppercase tracking-wider text-xs')}>
            Follow-ups
          </div>
          <div className="flex flex-wrap gap-2">
            {followups.map((q) => (
              <span
                key={q}
                className={cn(
                  'inline-flex items-center px-3 py-1 text-sm rounded-full',
                  'bg-muted/40 text-muted-foreground border border-border/50',
                )}
                title="Copy into the input above to ask"
              >
                {q}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
